export interface Location {
    id: number
    name: string
    address: string
    postal_code: string
    city: string

    coordinates: LocationCoordinates

    // latitude?: number;
    // longitude?: number;
    // distance?: number
}

export interface LocationCoordinates {
    type: string
    coordinates: Array<number>
}

export interface MapOptions {
    centerLat: number
    centerLng: number
}

export enum Step {
    postalCode = 0,
    location,
    userData,
    confirmation,
    error,
}
